// extracted by mini-css-extract-plugin
module.exports = {"baseSectionMessage":"baseSectionMessage--w7X+j","message":"message---Ggpn","button":"button--VcAId","list":"list--ngRV+","note":"note--LFpee"};